// frontend/src/lib/servings.ts

// Зажимает число едоков в разумный диапазон.
export function clampServings(n: number): number {
  return Math.min(20, Math.max(1, Math.round(n)));
}

// Штучные единицы (шт, шт., штук…) — округляем до целого; прочее (вес/объём) — до 1 знака.
function isCountUnit(unit: string | null | undefined): boolean {
  if (!unit) return false;
  return /^шт\.?$|^штук/i.test(unit.trim());
}

// Масштабирует количество ингредиента под N человек.
// amount 0/null/undefined → null («по вкусу», не масштабируем).
// servings отсутствует/<=0 → возвращаем amount как есть (масштабировать не от чего).
export function scaleAmount(
  amount: number | null | undefined,
  servings: number | undefined,
  n: number,
  unit: string | null | undefined,
): number | null {
  if (amount == null || amount === 0) return null;
  if (!servings || servings <= 0) return amount;
  const raw = (amount * n) / servings;
  if (isCountUnit(unit)) return Math.max(1, Math.round(raw));
  return Math.round(raw * 10) / 10;
}

// Отображение количества для текста списка: null → «по вкусу».
export function formatQty(amount: number | null, unit: string | null | undefined): string {
  if (amount === null) return 'по вкусу';
  return `${amount}${unit ? ` ${unit}` : ''}`;
}
